/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import RenderOption from "App/render/webgl/renderables/render_option";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import Pass from "App/render/webgl/passes/pass";
import WebGLContext from "App/web_gl_context";
import Factory from "App/render/webgl/renderables/factory";
import IScene from "js_interface/src/scene_interface";

export default
class PointRenderOption extends RenderOption {

    public static TypeName: string = "PointParams";

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);

        // default values
        this._props = null;
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): PointRenderOption {
        return new PointRenderOption(aSceneAPI, aRenderGraph);
    }

    public render(aRenderPass: Pass) {
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let view = aRenderPass.view;
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        super.render(aRenderPass);

        let size = view.getSizePct();
        let pixelRatioFactor = this._sceneAPI.renderSettingsModule.getQualityPerformanceFactor();
        gl.uniform1f(shader.uniformLocations.u_min_point_size, this._props.minPointSize * pixelRatioFactor * Math.min(size[0] / 100, size[1] / 100));
        gl.uniform1f(shader.uniformLocations.u_max_point_size, this._props.maxPointSize * pixelRatioFactor * Math.min(size[0] / 100, size[1] / 100));
        gl.uniform2fv(shader.uniformLocations.u_pin_point, this._props.pinPoint);
        gl.uniform2fv(shader.uniformLocations.u_glyph_size, this._props.glyphSize);
    }
}

Factory.register(PointRenderOption);
